import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { Badge } from '../../../models/badge.model';

type BadgeFilter = 'all' | 'unlocked' | 'locked' | 'bronze' | 'silver' | 'gold';

@Component({
  selector: 'app-badge-book-modal',
  templateUrl: './badge-book-modal.component.html',
  styleUrls: ['./badge-book-modal.component.scss'],
  standalone: false,
})
export class BadgeBookModalComponent {
  filter: BadgeFilter = 'all';
  private readonly tierOrder: Record<Badge['tier'], number> = {
    gold: 0,
    silver: 1,
    bronze: 2,
  };

  constructor(
    public sheetRef: MatBottomSheetRef<BadgeBookModalComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { badges: Badge[]; userName?: string },
  ) {}

  setFilter(filter: BadgeFilter): void {
    this.filter = filter;
  }

  get filteredBadges(): Badge[] {
    if (!this.data?.badges) {
      return [];
    }

    let badges: Badge[];

    if (this.filter === 'all') {
      badges = this.data.badges;
    } else if (this.filter === 'unlocked') {
      badges = this.data.badges.filter((badge) => badge.unlocked);
    } else if (this.filter === 'locked') {
      badges = this.data.badges.filter((badge) => !badge.unlocked);
    } else {
      badges = this.data.badges.filter((badge) => badge.tier === this.filter);
    }

    return [...badges].sort((a, b) => {
      if (a.unlocked !== b.unlocked) {
        return a.unlocked ? -1 : 1;
      }

      const tierDiff = this.tierOrder[a.tier] - this.tierOrder[b.tier];
      if (tierDiff !== 0) {
        return tierDiff;
      }

      return a.title.localeCompare(b.title);
    });
  }

  get emptyStateTitle(): string {
    switch (this.filter) {
      case 'unlocked':
        return 'Sin insignias desbloqueadas';
      case 'locked':
        return 'Sin insignias bloqueadas';
      case 'bronze':
        return 'Sin insignias de bronce';
      case 'silver':
        return 'Sin insignias de plata';
      case 'gold':
        return 'Sin insignias de oro';
      default:
        return 'Sin insignias disponibles';
    }
  }

  get emptyStateSubtitle(): string {
    if (this.filter === 'all') {
      return 'Todavía no hay insignias para mostrar en el libro scout.';
    }

    return 'Prueba con otra categoría para ver más insignias.';
  }
}
